import React from 'react';
import { useTranslation } from 'react-i18next';
import './UsecaseSection.css';
import {
  Minimize2, // Compact
  Wrench,    // Cost
  Leaf,      // Environment
  ScrollText,// Patented
  Waves,     // Shallow Waters
  ShieldCheck,// No Damage
  Scale,     // Compliance
  VolumeX    // Silent
} from 'lucide-react';

// Reusable Badge Component
const FeatureBadge = ({ title, icon: Icon, description }) => (
  <div className="feature-badge">
    <div className="badge-icon"><Icon size={36} /></div>
    <div className="badge-title">{title}</div>
    <div className="badge-description">{description}</div>
  </div>
);

function UsecaseSection() {
  const { t } = useTranslation();
  
  return (
    <section id="usecases" className="usecase-section content-panel">
      {/* Harmonized Header */}
      <div className="text-content text-center">
        <h2 className="usecase-headline">{t('usecaseTitle')}</h2>
        <p className="section-tagline prominent-subheadline"> 
          {t('usecaseSubtitle')}
        </p>
      </div>

      {/* Changed class to use card layout */}
      <div className="usecase-cards-container">
        {/* Usecase 1: Outboarder - Now as a card */}
        <div className="usecase-card outboard-card">
          <div className="card-content">
            <div className="usecase-model-container">
              <img 
                src="/images/pod.png" 
                alt="Outboarder Model" 
                className="usecase-image"
              />
            </div>
            <div className="usecase-text">
              <h4 className="usecase-heading">{t('outboarderHeading')}</h4>
              <div className="usecase-paragraphs">
                <p>{t('outboarderParagraph1')}</p>
                <p>{t('outboarderParagraph2')}</p>
                <p>{t('outboarderParagraph3')}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Usecase 2: Inboarder - Now as a card */}
        <div className="usecase-card inboard-card">
          <div className="card-content">
            <div className="usecase-model-container">
              <img 
                src="/images/inboard.png" 
                alt="Inboarder Model" 
                className="usecase-image"
              />
            </div>
            <div className="usecase-text">
              <h4 className="usecase-heading">{t('inboarderHeading')}</h4>
              <div className="usecase-paragraphs">
                <p>{t('inboarderParagraph1')}</p>
                <p>{t('inboarderParagraph2')}</p>
                <p>{t('inboarderParagraph3')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Value Proposition Badges at the bottom */}
      <div className="features-grid" style={{ marginTop: '3rem' }}>
        <FeatureBadge title={t('vpCompactTitle')} icon={Minimize2} description={t('vpCompactDesc')} />
        <FeatureBadge title={t('vpCostTitle')} icon={Wrench} description={t('vpCostDesc')} />
        <FeatureBadge title={t('vpEnvTitle')} icon={Leaf} description={t('vpEnvDesc')} />
        <FeatureBadge title={t('vpPatentedTitle')} icon={ScrollText} description={t('vpPatentedDesc')} />
        <FeatureBadge title={t('vpShallowTitle')} icon={Waves} description={t('vpShallowDesc')} />
        <FeatureBadge title={t('vpDamageTitle')} icon={ShieldCheck} description={t('vpDamageDesc')} />
        <FeatureBadge title={t('vpComplianceTitle')} icon={Scale} description={t('vpComplianceDesc')} />
        <FeatureBadge title={t('vpSilentTitle')} icon={VolumeX} description={t('vpSilentDesc')} />
      </div>
    </section>
  );
}

export default UsecaseSection; 